import React, {useState} from 'react';
import {FaArrowAltCircleUp} from 'react-icons/fa';
import { Button } from './Styles';

const ScrollButton = () =>{

const [visible, setVisible] = useState(false)

const toggleVisible = () => {
	const scrolled = document.documentElement.scrollTop;
	if (scrolled > 100){
	setVisible(true)
	}
	else if (scrolled <= 100){
	setVisible(false)
	}
};

const scrollToTop = () =>{
	window.scrollTo({
	top: 0,
	behavior: 'smooth'
	/* you can also use 'auto' behaviour
		in place of 'smooth' */
	});
};

window.addEventListener('scroll', toggleVisible);

return (

	<>
	<Button style={{display:"block"}}>

    <FaArrowAltCircleUp onClick={scrollToTop}
	style={{display: visible ? 'inline' : 'none'}} />

	<div style={{display:"block", marginLeft:"-25px", marginTop:"-5px", color:"black",}}>

	<p onClick={scrollToTop} style={{ display: visible ? 'inline' : 'none', fontSize:"13px", fontWeight:"900", }}>
	Scroll Up
	</p> 

	</div>
    
	</Button>

	
	</>
);
}

export default ScrollButton;
